/**
 * Utilities for detecting and communicating with Hotwire Native iOS app
 */

/**
 * Detect if the app is running inside Hotwire Native iOS wrapper
 */
export function isHotwireNative(): boolean {
  if (typeof navigator === 'undefined') return false;
  
  return (
    navigator.userAgent.includes('Hotwire Native') ||
    navigator.userAgent.includes('GoSitBack Admin')
  );
}
